import { useTypedSelector } from 'src/hooks';

export const useWidgetData = () => {
  const { access_token, selectedCompany, selectedCompanyAppData } = useTypedSelector(state => state.helper);
  const { teams = [] } = selectedCompanyAppData || {};
  const { uuid: selectedCompanyId = '' } = selectedCompany ?? {};

  return { access_token, teams, selectedCompanyId };
};
